import { render } from "./UrlView.vue?vue&type=template&id=bfacfc72&scoped=true&ts=true"
import script from "./UrlView.vue?vue&type=script&lang=ts"
export * from "./UrlView.vue?vue&type=script&lang=ts"

import "./UrlView.vue?vue&type=style&index=0&id=bfacfc72&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfacfc72"]])

export default __exports__